// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getSearchData = state => state.basketReducer.search;
export const getBasket = state => state.basketReducer.basket;
export const getError = state => state.basketReducer.errors.EAN;
export const getTotal = state => state.basketReducer.total;
export const getLoading = state => state.basketReducer.loading;
export const getVoucherCode = state => state.basketReducer.voucherCode;
export const getDeleteItem = state => state.basketReducer.deleteItem;
export const getIsEligibleForHomePickup = state => state.basketReducer.isEligibleForHomePickup;
export const getBasketNotifyError = state => state.basketReducer.basketNotifyError;
export const getDisableGetPriceButton = state => state.basketReducer.disableGetPriceButton;

export const getBookshopBasket = state => state.basketReducer.bookshopBasket;
